import React from "react";

// VIL logo — uses brand asset PNG (red flame + blue wave) + "VIL" wordmark
export const Logo = ({ className = "", showWordmark = true, dark = false }) => {
    return (
        <div className={`flex items-center gap-0 ${className}`} data-testid="vil-logo">
            <img
                src="https://customer-assets.emergentagent.com/job_vil-fire-safety/artifacts/vs4kjpxo_image.png"
                alt="VIL fire & water logo"
                className="h-12 w-12 object-contain"
                width="48"
                height="48"
            />
            {showWordmark && (
                <span
                    className={`font-display font-black text-2xl tracking-tight -ml-1 ${dark ? "text-white" : "text-slate-900"}`}
                    style={{ letterSpacing: "0.06em" }}
                >
                    VIL
                </span>
            )}
        </div>
    );
};

export default Logo;
